import { Icon, Label, Loader, Text } from "@avanadeits/vangogh";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { AvanadeRequestIntro } from "../../features/target-users/approve-reject-requests-form/avanade/components/AvandeRequestIntro";
import { StaticAvanadeRequestForm } from "../../features/target-users/approve-reject-requests-form/avanade/StaticAvanadeRequestForm";
import { RejectRequestForm } from "../../features/target-users/approve-reject-requests-form/common/RejectRequestForm";
import { ApproveRequestForm } from "../../features/target-users/approve-reject-requests-form/common/ApproveRequestForm";
import { useLoadAvanadeRequest } from "../../features/target-users/approve-reject-requests-form/avanade/hooks/useLoadAvanadeRequest";
import { RequestTypeInfo } from "../../features/target-users/approve-reject-requests-form/common/RequestTypeInfo";
import avanadeRequestsService from "../../services/avanadeRequestsService";
import { AvanadeRequest } from "../../models/AvanadeRequest";
import { SimpleSelect } from "../../features/source-users/requests-forms/Common/SimpleSelect";
import { CorporateOptionType } from "../../models/CorporateOptionType";
import { StaticInputField } from "../../features/target-users/approve-reject-requests-form/common/fields/StaticInputField";

export const ApproveRejectAvanadeRequestPage = () => {
  const { requestGuid } = useParams();
  const navigator = useNavigate();
  const { request, isRequestLoading } = useLoadAvanadeRequest(requestGuid);

  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [fieldValue, setFieldValue] = useState<CorporateOptionType | null>(null);

  useEffect(() => {
    if (request && !isRequestLoading && request?.userRequestStatus !== "Pending") {
      const isCorporateFunction = !!request?.isCorporateFunction
      if (typeof request?.isCorporateFunction === 'boolean') {
        setFieldValue({
          value: isCorporateFunction,
          label: isCorporateFunction ? 'Yes' : 'No'
        })
      }
    }
  }, [request, isRequestLoading])

  const handleApprove = async () => {
    try {
      setIsSubmitting(true);
      await avanadeRequestsService.approveAvanadeRequest(request!.guid.value, fieldValue?.value);
      setIsSubmitting(false);
      toast.success("Request approved.");
      setTimeout(() => {
        navigator("/");
      }, 1500);
    } catch (error) {
      toast.error("Something went wrong.");
      setTimeout(() => {
        navigator("/");
      }, 1500);
    }
  };

  const handleReject = async (x: { reason: string }) => {
    try {
      setIsSubmitting(true);
      await avanadeRequestsService.rejectAvanadeRequest(
        request?.guid.value!,
        x.reason
      );
      setIsSubmitting(false);
      toast.success("Request rejected.");
      setTimeout(() => {
        navigator("/");
      }, 1500);
    } catch (error) {
      toast.error("Something went wrong.");
      setTimeout(() => {
        navigator("/");
      }, 1500);
    }
  };

  if (isRequestLoading) {
    return <Loader />;
  }

  const handleValidate = () => {
    if (!fieldValue) {
      setError('Please select one option.');
    } else {
      setError(null);
      handleApprove()
    }
  }

  return (
    <>
      <RequestTypeInfo type="Avanade Account" />
      <div className="IP-create-form">
        <AvanadeRequestIntro {...request} />
        {isSubmitting ? (
          <div style={loaderStyle}>
            <Loader />
          </div>
        ) : (
          <>
            <StaticAvanadeRequestForm request={request!} />
            <>
              <div></div>
              <div>
                {request?.userRequestStatus === "Pending" ? <SimpleSelect
                  label="5. Does Account represents Corporate Functions Employee? *"
                  id={'123'}
                  onChange={(e: any) => {
                    setFieldValue(e);
                    setError(null)
                  }}
                  value={fieldValue}
                  options={[
                    {
                      label: "Yes",
                      value: true,
                    },
                    {
                      label: "No",
                      value: false,
                    }
                  ]}
                /> : <StaticInputField
                  label="5. Does Account represents Corporate Functions Employee? *"
                  value={fieldValue?.label ? fieldValue?.label : ''}
                />}
                {error && <Text size="xs" colorText="error" style={{ marginTop: "8px" }}>
                  <Icon size="xxs" colorText="error" name="error" /> Error: Please select one option.
                </Text>}
              </div>
            </>
            {request?.userRequestStatus === "Pending" && (
              <div className="IP-create-form__fr --for-approve">
                <RejectRequestForm
                  // request={request!}
                  handleReject={handleReject}
                />
                <span></span>
                <ApproveRequestForm handleApprove={handleValidate} />
              </div>
            )}
            {request?.userRequestStatus === "Rejected" && (
              <Label colorOutline={"default"}>
                <Label.Inner>
                  <Label.Header>
                    <Label.HeaderMain>
                      <Text>Reason of rejecting:</Text>
                    </Label.HeaderMain>
                  </Label.Header>
                  <Label.Body>
                    <Text>"{request?.rejectReason}"</Text>
                  </Label.Body>
                </Label.Inner>
              </Label>
            )}
          </>
        )}
      </div>
    </>
  );
};

const loaderStyle = {
  gridColumn: "span 2",
  display: "flex",
  justifyContent: "center",
};
